"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", ";\n"], ["\n  height: ", ";\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height + "px";
}, function (_a) {
    var bgColor = _a.bgColor;
    return bgColor;
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return borderRadius + "px";
});
var FilledStyle = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  width: ", ";\n  background-color: ", ";\n  border-radius: inherit;\n  text-align: ", ";\n  transition: width 1s ease-in-out;\n"], ["\n  height: 100%;\n  width: ", ";\n  background-color: ", ";\n  border-radius: inherit;\n  text-align: ", ";\n  transition: width 1s ease-in-out;\n"])), function (_a) {
    var completed = _a.completed;
    return completed + "%";
}, function (_a) {
    var bgColorActive = _a.bgColorActive;
    return bgColorActive;
}, function (_a) {
    var textAlign = _a.textAlign;
    return textAlign;
});
var LabelStyle = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 5px;\n  color: #fff;\n  font-weight: bold;\n"], ["\n  padding: 5px;\n  color: #fff;\n  font-weight: bold;\n"])));
var ProgressBar = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 3 : _b, _c = _a.borderRadius, borderRadius = _c === void 0 ? 2 : _c, _d = _a.bgColor, bgColor = _d === void 0 ? '#e0e0de' : _d, _e = _a.bgColorActive, bgColorActive = _e === void 0 ? '#4dc8c8' : _e, completed = _a.completed, _f = _a.showNumber, showNumber = _f === void 0 ? false : _f, _g = _a.textAlign, textAlign = _g === void 0 ? 'right' : _g;
    return (react_1.default.createElement(Container, { height: height, borderRadius: borderRadius, bgColor: bgColor },
        react_1.default.createElement(FilledStyle, { completed: completed, bgColorActive: bgColorActive, textAlign: textAlign }, showNumber && react_1.default.createElement(LabelStyle, null, completed + "%"))));
};
exports.default = ProgressBar;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ProgressBar.js.map